var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoposts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 610.42 334.05",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 180.12,
    y: 306.05,
    width: 107.7,
    height: 27.89,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.12,
    y: 257.1,
    width: 230.66,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.85,
    y: 282.07,
    width: 22,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89.12,
    y: 153.03,
    width: 317.51,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180.12,
    y: 100.03,
    width: 226.51,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.19,
    y: 48.03,
    width: 268.44,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.19,
    y: 0.03,
    width: 175.66,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.63,
    y: 48.03,
    width: 19.81,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 502.83,
    y: 178.03,
    width: 42,
    height: 27.95,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.12,
    cy: 320.05,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 286.12,
    cy: 320.05,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 75.12,
    cy: 271.05,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 305.85,
    cy: 271.05,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 367.85,
    cy: 296.05,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.77,306.05c-5.72,0-10.35-4.69-10.35-10.47s4.63-10.47,10.35-10.47c.12,0,.23.01.35.02v-7.55h-82.98v7.36c.43-.05.86-.08,1.3-.08,5.72,0,10.35,4.8,10.35,10.74s-4.63,10.74-10.35,10.74c-.44,0-.87-.03-1.3-.08v.33h82.98v-.55c-.11,0-.23.01-.35.01Z",
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 389.85,
    cy: 296.05,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 448.63,
    cy: 243.1,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 124.19,
    cy: 220,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.19,177v3.97c6.9,0,12.5,5.61,12.5,12.53s-5.6,12.53-12.5,12.53v.97h320.64v-30H138.19Z",
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.34,228.6v5.42c.12,0,.24-.02.37-.02,6.38,0,11.55,5.17,11.55,11.55s-5.17,11.55-11.55,11.55c-.12,0-.25-.01-.37-.02v.52h272v-29H176.34Z",
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M420.63,206.24v-.21h-1.4c.47.04.94.11,1.4.21Z",
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.18,229.07c-6.38,0-11.55-5.17-11.55-11.55,0-6.03,4.61-10.97,10.5-11.5H124.19v27.95h296.44v-5.17c-.79.18-1.61.27-2.45.27Z",
    fill: "#44bac5"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 458.83,
    cy: 192,
    r: 15,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 502.83,
    cy: 192,
    r: 14,
    transform: "translate(232.76 657.58) rotate(-80.78)",
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 544.83,
    cy: 192,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 89.12,
    cy: 167,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 180.12,
    cy: 114,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 152.19,
    cy: 62,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.08,48.03c-5.53,0-10.01-4.48-10.01-10.01s4.48-10.01,10.01-10.01c.26,0,.51.02.76.04v-5.04h-117.46v5.01c5.36.19,9.64,4.59,9.64,10s-4.28,9.82-9.64,10.01v2.93h117.46v-2.96c-.25,0-.5.03-.76.03Z",
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.19,
    cy: 14,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 375.85,
    cy: 14,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 420.63,
    cy: 62,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462.63,
    cy: 62,
    r: 14,
    fill: "#44bac5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 482.43,
    cy: 62,
    r: 14,
    fill: "#44bac5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M594.21,233.35v-9c0-1.1.9-2,2-2h0c1.1,0,2,.9,2,2v9h-4Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.21,248.77v-9h4v9c0,1.1-.9,2-2,2h0c-1.11,0-2-.9-2-2Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.42,234.56h9c1.1,0,2,.9,2,2h0c0,1.1-.9,2-2,2h-9v-4Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584,234.56h9v4h-9c-1.1,0-2-.9-2-2h0c0-1.1.9-2,2-2Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.21,233.35v-9c0-1.1.9-2,2-2h0c1.1,0,2,.9,2,2v9h-4Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.21,248.77v-9h4v9c0,1.1-.9,2-2,2h0c-1.11,0-2-.9-2-2Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.42,234.56h9c1.1,0,2,.9,2,2h0c0,1.1-.9,2-2,2h-9v-4Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2,234.56h9v4H2c-1.1,0-2-.9-2-2h0c0-1.1.9-2,2-2Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M543.77,315.9v-7.93c0-.64.52-1.16,1.16-1.16h.99c.64,0,1.16.52,1.16,1.16v7.93h-3.31Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M543.77,329.14v-7.93h3.31v7.93c0,.64-.52,1.16-1.16,1.16h-.99c-.64,0-1.16-.52-1.16-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.08,316.9h7.93c.64,0,1.16.52,1.16,1.16v.99c0,.64-.52,1.16-1.16,1.16h-7.93v-3.31Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M534.84,316.9h7.93v3.31h-7.93c-.64,0-1.16-.52-1.16-1.16v-.99c0-.64.52-1.16,1.16-1.16Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M62.8,315.9v-7.93c0-.64.52-1.16,1.16-1.16h.99c.64,0,1.16.52,1.16,1.16v7.93h-3.31Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.8,329.14v-7.93h3.31v7.93c0,.64-.52,1.16-1.16,1.16h-.99c-.64,0-1.16-.52-1.16-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.11,316.9h7.93c.64,0,1.16.52,1.16,1.16v.99c0,.64-.52,1.16-1.16,1.16h-7.93v-3.31Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.87,316.9h7.93v3.31h-7.93c-.64,0-1.16-.52-1.16-1.16v-.99c.01-.64.52-1.16,1.16-1.16Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M527.36,42.58v-7.24c0-.64.52-1.16,1.16-1.16h.74c.64,0,1.16.52,1.16,1.16v7.24s-3.06,0-3.06,0Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.36,54.72v-7.24h3.05v7.24c0,.64-.52,1.16-1.16,1.16h-.74c-.64-.01-1.15-.52-1.15-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M531.33,43.5h7.24c.64,0,1.16.52,1.16,1.16v.74c0,.64-.52,1.16-1.16,1.16h-7.24v-3.06Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M519.19,43.5h7.24v3.05h-7.24c-.64,0-1.16-.52-1.16-1.16v-.74c0-.63.52-1.15,1.16-1.15Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M83.04,42.58v-7.24c0-.64.52-1.16,1.16-1.16h.74c.64,0,1.16.52,1.16,1.16v7.24s-3.06,0-3.06,0Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.04,54.72v-7.24h3.05v7.24c0,.64-.52,1.16-1.16,1.16h-.74c-.64-.01-1.15-.52-1.15-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.01,43.5h7.24c.64,0,1.16.52,1.16,1.16v.74c0,.64-.52,1.16-1.16,1.16h-7.24v-3.06Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.87,43.5h7.24v3.05h-7.24c-.64,0-1.16-.52-1.16-1.16v-.74c.01-.63.52-1.15,1.16-1.15Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M488.07,105.86v-5.75c0-.64.52-1.16,1.16-1.16h.2c.64,0,1.16.52,1.16,1.16v5.75h-2.52Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.07,115.64v-5.75h2.51v5.75c0,.64-.52,1.16-1.16,1.16h-.2c-.63,0-1.15-.52-1.15-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.34,106.62h5.75c.64,0,1.16.52,1.16,1.16v.2c0,.64-.52,1.16-1.16,1.16h-5.75v-2.52Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.55,106.62h5.75v2.51h-5.75c-.64,0-1.16-.52-1.16-1.16v-.2c.01-.64.53-1.15,1.16-1.15Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M122.39,105.86v-5.75c0-.64.52-1.16,1.16-1.16h.2c.64,0,1.16.52,1.16,1.16v5.75h-2.52Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.39,115.64v-5.75h2.51v5.75c0,.64-.52,1.16-1.16,1.16h-.2c-.64,0-1.15-.52-1.15-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.66,106.62h5.75c.64,0,1.16.52,1.16,1.16v.2c0,.64-.52,1.16-1.16,1.16h-5.75v-2.52Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.87,106.62h5.75v2.51h-5.75c-.64,0-1.16-.52-1.16-1.16v-.2c.01-.64.52-1.15,1.16-1.15Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M556.35,147.28v-8.26c0-.64.52-1.16,1.16-1.16h1.11c.64,0,1.16.52,1.16,1.16v8.26h-3.43Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556.35,161.03v-8.26h3.42v8.26c0,.64-.52,1.16-1.16,1.16h-1.11c-.63,0-1.15-.52-1.15-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.81,148.31h8.26c.64,0,1.16.52,1.16,1.16v1.11c0,.64-.52,1.16-1.16,1.16h-8.26v-3.43Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.06,148.31h8.26v3.42h-8.26c-.64,0-1.16-.52-1.16-1.16v-1.11c0-.63.52-1.15,1.16-1.15Z",
    fill: "#45b9c5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M58.17,147.28v-8.26c0-.64.52-1.16,1.16-1.16h1.11c.64,0,1.16.52,1.16,1.16v8.26h-3.43Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.17,161.03v-8.26h3.42v8.26c0,.64-.52,1.16-1.16,1.16h-1.11c-.64,0-1.15-.52-1.15-1.16Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.62,148.31h8.26c.64,0,1.16.52,1.16,1.16v1.11c0,.64-.52,1.16-1.16,1.16h-8.26s0-3.43,0-3.43Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.87,148.31h8.26v3.42h-8.26c-.64,0-1.16-.52-1.16-1.16v-1.11c.01-.63.52-1.15,1.16-1.15Z",
    fill: "#45b9c5"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M208.19,272.18V77.11c0-5.79,4.22-10.71,9.95-11.62l174.47-27.65c7.15-1.13,13.63,4.35,13.66,11.57l1.09,235.21c.03,6.85-5.79,12.28-12.65,11.79l-175.56-12.49c-6.17-.44-10.96-5.57-10.96-11.74Z",
    fill: "#c6e1e5",
    stroke: "#222931",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.19,272.1V77.03c0-5.79,4.12-10.71,9.71-11.62l170.24-27.65c6.98-1.13,13.3,4.35,13.33,11.57l1.06,235.21c.03,6.85-5.65,12.28-12.34,11.79l-171.3-12.49c-6.03-.44-10.7-5.56-10.7-11.74Z",
    fill: "#fff",
    stroke: "#222931",
    strokeMiterlimit: 10,
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.83,231.49V100.79c0-1.04.76-1.93,1.8-2.09l176.84-17.86c1.28-.19,2.43.8,2.43,2.09v155.68c0,1.2-1,2.16-2.2,2.11l-176.84-7.12c-1.14-.05-2.03-.98-2.03-2.11Z",
    fill: "#92b2b5",
    isolation: "isolate",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.16,242.47c0,1.26-.64,2.36-1.6,3.01h0l-4.29,4.12c-.24.23-.6.23-.84,0l-4.35-4.18c-.92-.66-1.52-1.74-1.52-2.95,0-2,1.62-3.63,3.63-3.63,1.06,0,2.01.45,2.67,1.17.66-.72,1.61-1.17,2.67-1.17,2.02,0,3.64,1.63,3.64,3.63Z",
    fill: "none",
    stroke: "#222931",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.23,247.95c.71-.95,1.14-2.13,1.14-3.41,0-3.14-2.55-5.69-5.69-5.69s-5.69,2.55-5.69,5.69,2.55,5.69,5.69,5.69c1.27,0,2.44-.42,3.38-1.12l2.3,1.06-1.13-2.22Z",
    fill: "none",
    stroke: "#222931",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "267.21 241.06 253.77 240.72 258.3 245.93 259.76 252.25 267.21 241.06",
    fill: "none",
    stroke: "#222931",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.12,
    y1: 245.72,
    x2: 267.21,
    y2: 241.06,
    fill: "none",
    stroke: "#222931",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M370.83,259.15l-.09-13.63c0-.17.14-.31.32-.3l15.32.84c.16.01.28.14.29.3l.17,13.54c0,.24-.26.39-.46.26l-7.7-4.73c-.09-.06-.21-.06-.31-.01l-7.09,4c-.2.1-.44-.04-.45-.27Z",
    fill: "#222931"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M240.99,80.51c.09,2.92-1.1,5.58-3.06,7.45-1.69,1.6-3.95,2.62-6.46,2.7-2.51.08-4.83-.79-6.62-2.28-2.08-1.74-3.43-4.32-3.53-7.24-.17-5.43,4.09-9.97,9.52-10.14,5.44-.18,9.98,4.08,10.15,9.51Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.08,
    cy: 78.25,
    r: 3.65,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.93,87.95c-1.69,1.6-3.95,2.62-6.46,2.7-2.51.08-4.83-.79-6.62-2.28.64-2.96,3.22-5.21,6.37-5.31,3.17-.11,5.89,1.98,6.71,4.89Z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.65,74.35h0c-.09-.66.37-1.27,1.03-1.36l16.44-2.27c.66-.09,1.27.37,1.36,1.03h0c.09.66-.37,1.27-1.03,1.36l-16.44,2.27c-.66.09-1.27-.37-1.36-1.03Z",
    fill: "#222931"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.65,79.78h0c-.09-.66.37-1.27,1.03-1.36l10.76-1.49c.66-.09,1.27.37,1.36,1.03h0c.09.66-.37,1.27-1.03,1.36l-10.76,1.49c-.66.09-1.27-.37-1.36-1.03Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.64,71.31h0c-.09-.66.37-1.27,1.03-1.36l5.3-.73c.66-.09,1.27.37,1.36,1.03h0c.09.66-.37,1.27-1.03,1.36l-5.3.73c-.66.09-1.27-.37-1.36-1.03Z",
    fill: "#45b9c5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.6,259.96h0c.02-.67.58-1.19,1.25-1.17l41.29,1.36c.67.02,1.19.58,1.17,1.25h0c-.02.67-.58,1.19-1.25,1.17l-41.29-1.36c-.67-.02-1.19-.58-1.17-1.25Z",
    fill: "#3a485c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.56,265.35h0c.02-.67.58-1.19,1.25-1.17l28.11.92c.67.02,1.19.58,1.17,1.25h0c-.02.67-.58,1.19-1.25,1.17l-28.11-.92c-.67-.03-1.19-.59-1.17-1.25Z",
    fill: "#42b8c4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.47,261.71h0c.02-.67.58-1.19,1.25-1.17l15.43.51c.67.02,1.19.58,1.17,1.25h0c-.02.67-.58,1.19-1.25,1.17l-15.43-.51c-.67-.03-1.2-.59-1.17-1.25Z",
    fill: "#42b8c4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoposts);
export default __webpack_public_path__ + "static/media/No posts.1920e0f44e863b721b31e8de0d4338af.svg";
export { ForwardRef as ReactComponent };